// @flow

import * as React from 'react';
import Config from '@insolus/config';
import Medias from '../../components/Medias';

const MediasElement = (): React.Node => {
    const { Medias: mediaItems } = Config.get('data');

    const items = mediaItems
        .filter(({ type }) => type !== 'application/pdf')
        .map(({ adId, showcaseId, ...item }) => item);

    return (
        <Medias
            items={items}
            isMobile={Config.get('serverContext.isMobile')}
        />
    );
};

export default MediasElement;
